// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgramCase-module__tabsBox--rF3yf>div>div {
    display: flex;
    flex-wrap: wrap;
}

.ProgramCase-module__tabsBox--rF3yf {
    max-width: 1000px;
}

.ProgramCase-module__btnSettings--aKzZr {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ProgramCase-module__alertBox--PuVDG {
    display: flex;
    justify-content: center;
    align-items: center;
}

.ProgramCase-module__setting--AEGT8 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
}

.ProgramCase-module__downloadBox--NC6Hy {
    display: flex;
    gap: 10px;
}

.ProgramCase-module__icon--HViEb>svg {
    font-size: 14px;
}

.ProgramCase-module__icon--HViEb {
    display: flex
}`, "",{"version":3,"sources":["webpack://./src/pages/program-case/ProgramCase.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ","sourcesContent":[".tabsBox>div>div {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.tabsBox {\r\n    max-width: 1000px;\r\n}\r\n\r\n.btnSettings {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.alertBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.setting {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 15px;\r\n}\r\n\r\n.downloadBox {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.icon>svg {\r\n    font-size: 14px;\r\n}\r\n\r\n.icon {\r\n    display: flex\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsBox": `ProgramCase-module__tabsBox--rF3yf`,
	"btnSettings": `ProgramCase-module__btnSettings--aKzZr`,
	"alertBox": `ProgramCase-module__alertBox--PuVDG`,
	"setting": `ProgramCase-module__setting--AEGT8`,
	"downloadBox": `ProgramCase-module__downloadBox--NC6Hy`,
	"icon": `ProgramCase-module__icon--HViEb`
};
export default ___CSS_LOADER_EXPORT___;
